import { useState } from "react";
import AccordionItem from "./accordionItem";
import { useTranslation } from "react-i18next";

const FaQs = () => {
  const { t } = useTranslation();

  const faqItems = Array.from({ length: 37 }, (_, i) => ({
    question: `${i + 1}Q`,
    answer: `${i + 1}A`,
  }));

  const [openIndex, setOpenIndex] = useState(null);

  const handleClick = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };
  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto">
          <h1 className="text-mainBlue text-[24px] md:text-[32px] font-bold text-center">
            {t("FAQs")}
          </h1>
          <p className="text-lg text-center text-mainGray">{t("frequentlyAsked")}</p>

          <div className="mt-10 space-y-5">
            {faqItems.map((item, index) => (
              <AccordionItem
                key={index}
                question={item.question}
                answer={item.answer}
                isOpen={openIndex === index}
                onClick={() => handleClick(index)}
              />
            ))}
          </div>
        </div>
      </article>
    </main>
  );
};

export default FaQs;
